import {
  getKidsBoy412GarmentIcon,
  kidsBoyUses412Assets,
} from './kidsBoy412GarmentAssets';
import {
  getKidsGirl412GarmentIcon,
  kidsGirlUses412Assets,
} from './kidsGirl412GarmentAssets';
import { resolveKidsCatalogCategory } from '../utils/kidsProductCatalog';

/** Full garment inspiration PNGs under `public/assets/inspiration/` */
const PUBLIC = process.env.PUBLIC_URL || '';
const WOMENS_INSPIRATION = `${PUBLIC}/assets/inspiration/womens`;
const MENS_INSPIRATION = `${PUBLIC}/assets/inspiration/mens`;
const MENS_BLAZER_INSPIRATION = `${PUBLIC}/assets/Mens Blazer`;
const MENS_SHIRT_INSPIRATION = `${PUBLIC}/assets/Mens Shirt`;
const WOMEN_SHIRT_INSPIRATION = `${PUBLIC}/assets/women shirt `;
const KIDS_ASSETS = `${PUBLIC}/assets/kids`;

function encodeAssetPath(p) {
  if (typeof p !== 'string' || !p) return p;
  const qIdx = p.indexOf('?');
  const pathPart = qIdx >= 0 ? p.slice(0, qIdx) : p;
  const query = qIdx >= 0 ? p.slice(qIdx) : '';
  if (!pathPart.startsWith('/')) return encodeURI(p);
  const encoded = pathPart
    .split('/')
    .map((segment) => (segment ? encodeURIComponent(segment) : segment))
    .join('/');
  return encoded + query;
}

/** Toddler model previews for kids categories on the generate page */
export const KIDS_BOY_TODDLER_PREVIEW = `${KIDS_ASSETS}/boy toddler .png`;
export const KIDS_GIRL_TODDLER_PREVIEW = `${KIDS_ASSETS}/Girl toddler.png`;

/** Category selector thumbnails on the generate page */
export const WOMEN_CLOTHING_CATEGORY_PREVIEW = `${WOMENS_INSPIRATION}/Dress.png`;
export const MEN_CLOTHING_CATEGORY_PREVIEW = `${MENS_INSPIRATION}/Kurta.png`;
export const KIDS_BOY_CATEGORY_PREVIEW = MEN_CLOTHING_CATEGORY_PREVIEW;

export { encodeAssetPath };

export const WOMEN_GARMENT_INSPIRATION_BY_VALUE = {
  dress: `${WOMENS_INSPIRATION}/Dress.png`,
  frock: `${WOMENS_INSPIRATION}/Dress.png`,
  top: `${WOMENS_INSPIRATION}/Top.png`,
  shirt: `${WOMEN_SHIRT_INSPIRATION}/Neck line /Classic collar_.png`,
  skirt: `${WOMENS_INSPIRATION}/Skirt.png`,
  tshirt: `${WOMENS_INSPIRATION}/T-shirt.png`,
  jeans: `${WOMENS_INSPIRATION}/Bottom.png`,
  trouser: `${WOMENS_INSPIRATION}/Bottom.png`,
  shorts: `${WOMENS_INSPIRATION}/Bottom.png`,
  lehenga: `${WOMENS_INSPIRATION}/Lehenga.png`,
  blouses: `${WOMENS_INSPIRATION}/Blouse.png`,
  'saree-styles': `${WOMENS_INSPIRATION}/Saree.png`,
  'night-wear': `${WOMENS_INSPIRATION}/Nightwear.png`,
  lingerie: `${WOMENS_INSPIRATION}/Lingerie.png`,
  blazer: `${WOMENS_INSPIRATION}/Jacket.png`,
  hoodies: `${WOMENS_INSPIRATION}/Jacket.png`,
  layering: `${WOMENS_INSPIRATION}/Jacket.png`,
  jacket: `${WOMENS_INSPIRATION}/Jacket.png`,
  sweater: `${WOMENS_INSPIRATION}/Jacket.png`,
  socks: `${PUBLIC}/assets/womens wear/socks.png`,
};

export const MEN_GARMENT_INSPIRATION_BY_VALUE = {
  kurta: `${MENS_INSPIRATION}/Kurta.png`,
  shirt: `${MENS_SHIRT_INSPIRATION}/sleeves/Full sleeve.png`,
  tshirt: `${MENS_INSPIRATION}/t shirt.png`,
  trouser: `${MENS_INSPIRATION}/Trousers.png`,
  blazer: `${MENS_BLAZER_INSPIRATION}/collars/Standard blazer collar.png`,
  jacket: `${MENS_INSPIRATION}/Jacket.png`,
  waistcoat: `${MENS_INSPIRATION}/waistcoat.png`,
  'kurta-dhoti': `${MENS_INSPIRATION}/Dhoti.png`,
  pajama: `${MENS_INSPIRATION}/Payjama.png`,
  cordset: `${MENS_INSPIRATION}/Shirt.png`,
  socks: `${PUBLIC}/assets/Mens wear/socks.png`,
};

export function hasGarmentInspirationCategory(categoryValue) {
  return (
    categoryValue === 'women-clothing' ||
    categoryValue === 'men-clothing' ||
    categoryValue === 'kids-boy' ||
    categoryValue === 'kids-girl'
  );
}

export function getGarmentInspirationImage(categoryValue, typeValue, kidAgeRange = null) {
  if (!categoryValue || !typeValue) return null;
  if (categoryValue === 'kids-girl' && kidsGirlUses412Assets(kidAgeRange)) {
    return getKidsGirl412GarmentIcon(typeValue);
  }
  if (categoryValue === 'kids-boy' && kidsBoyUses412Assets(kidAgeRange)) {
    return getKidsBoy412GarmentIcon(typeValue);
  }
  if (categoryValue === 'kids-boy' && typeValue === 'toddler-dress') {
    return KIDS_BOY_TODDLER_PREVIEW;
  }
  if (categoryValue === 'kids-girl' && typeValue === 'toddler-dress') {
    return KIDS_GIRL_TODDLER_PREVIEW;
  }
  const catalogCategory = resolveKidsCatalogCategory(categoryValue, kidAgeRange);
  if (catalogCategory === 'women-clothing') {
    const normalized = String(typeValue).toLowerCase();
    if (normalized === 'shirt' || normalized.startsWith('shirt-')) {
      return WOMEN_GARMENT_INSPIRATION_BY_VALUE.shirt;
    }
    return WOMEN_GARMENT_INSPIRATION_BY_VALUE[typeValue] || null;
  }
  if (catalogCategory === 'men-clothing') {
    return MEN_GARMENT_INSPIRATION_BY_VALUE[typeValue] || null;
  }
  return null;
}
